import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainNavigationComponent } from '@ace/ace';
import { AuthserviceService } from "@ace/ace";

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('@ace/ace').then((m) => m.LoginModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('@ace/ace').then(
        (m) => m.ForgotPasswordModule,
      )
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('@ace/ace').then((m) => m.ResetPasswordModule),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'main',
    component: MainNavigationComponent,
    children: [
      {
        path: 'landing-page',
        loadChildren: () =>
          import("./layouts/landing-page/landing-page.module").then(
            (m) => m.LandingPageModule,
          )
      },
      {
        path: 'master-management-v2',
        loadChildren: () =>
          import(
            '@ace/ace'
          ).then((m) => m.MasterManagementV2Module),
      },
      {
        path: 'inquiries',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.InquiriesModule),
      },
      {
        path: 'tasks',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.TasksModule),
      },
      {
        path: 'system-reports',
        loadChildren: () =>
          import("./layouts/system-reports/system-reports.module").then(
            (m) => m.SystemReportsModule,
          )
      },
      {
        path: "user-management",
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.UserManagementModule,
          )
      },
      {
        path: 'security',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.SecurityModule),
      },
      {
        path: "chapter-management",
        loadChildren: () =>
          import("./layouts/chapter-management/chapter-management.module").then(
            (m) => m.ChapterManagementModule,
          )
      },
      {
        path: "report-management",
        loadChildren: () =>
          import("./layouts/report-management/report-management.module").then(
            (m) => m.ReportManagementModule,
          )
      },
      {
        path: "template-management",
        loadChildren: () =>
          import("./layouts/template-management/template-management.module").then(
            (m) => m.TemplateManagementModule,
          )
      },
      {
        path: 'upload-management',
        loadChildren: () =>
          import("./layouts/upload-management/upload-management.module").then(
            (m) => m.UploadManagementModule,
          )
      },
      {
        path: 'dataset-management',
        loadChildren: () =>
          import("./layouts/dataset-management/dataset-management.module").then(
            (m) => m.DatasetManagementModule,
          )
      },
      {
        path: 'data-integration-copy',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.DataIntegrationModule),
      },
      {
        path: 'data-integration',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.DataIntegrationModule),
      },
      {
        path: "workflow-management",
        loadChildren: () =>
          import("./layouts/workflow-management/workflow-management.module").then(
            (m) => m.WorkflowManagementModule,
          )
      },
    ], canActivate: [AuthserviceService]
  },
  // { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
